var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWellness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / wellness") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B32",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0C1D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-wellness",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9991862,13.9418972 C12.5333245,13.1564978 13.1491685,12.451095 13.8362608,11.8369193 C14.63167,11.0614889 15.4854287,10.4494292 16.3470813,9.95443464 C15.6620642,7.01693823 14.1920953,4.41065886 12.31665,2.77858078 C12.1454263,2.62941104 11.8575034,2.62941104 11.6858321,2.77858078 C9.81124128,4.40943816 8.34127238,7.01315405 7.65499392,9.94816837 C8.50374776,10.4356759 9.34249186,11.0373191 10.1225202,11.7977348 C10.8356541,12.4367314 11.4586595,13.1480343 11.9991862,13.9418972 Z M20.3012594,17.9635801 C23.7029072,14.9148371 23.9903825,10.8227604 24,9.65943174 C24.0016536,9.47526856 23.8608253,9.33277199 23.6770691,9.33358232 C22.4670689,9.33899757 18.051669,9.59025865 14.7670865,12.7919149 C13.3870833,14.0264918 12.5437412,15.4294035 12,16.7444247 C11.4562588,15.4294035 10.6129167,14.0264918 9.23291354,12.7919149 C5.94833097,9.59025865 1.53293109,9.33899757 0.322930941,9.33358232 C0.139174655,9.33277199 -0.00165362343,9.47526856 -2.84217094e-14,9.65943174 C0.00961752165,10.8227604 0.297499657,14.915244 3.69874062,17.9635801 C6.9976187,21.1760724 10.2665085,21.3266149 11.7483284,21.3332965 L12.2516639,21.3332965 C13.733403,21.3266591 17.0016144,21.1764559 20.3012594,17.9635801 Z",
    id: "icon",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellness);
export default __webpack_public_path__ + "static/media/wellness.45d17c53aac4f227464182b0f299a7c3.svg";
export { ForwardRef as ReactComponent };